<span class="status-badge" [ngClass]="'status-badge--' + tone">
  <span class="status-badge__dot" aria-hidden="true"></span>
  <span class="status-badge__label">{{ label }}</span>
</span>
